import { createSlice } from '@reduxjs/toolkit';
import apiClient from '@miroculus/api-client';
import { startExperiment } from '../devices';
import navigationService from '../../navigation/navigationService';
import { ANACONDA_URL, instrumentsUrl } from '../../constants/routes';
import { TYPE_EXPERIMENT, TYPE_DEVICE, DEVICE_STATUS_AVAILABLE, EXPERIMENT_STATUS_FINISH, } from '../../constants';
import socketClient from '../../socketClient';
import { updateScript, onScriptEnds } from '../codeEditor';
import { updateMoveBackbone } from '../electrodeLayout';
const initialState = {
    loadingProjects: false,
    projects: null,
    selectedProjectId: '',
    experiment: {},
    feedback: '',
    showingFinishModal: false,
};
const experimentSlice = createSlice({
    name: 'experiment',
    initialState,
    reducers: {
        updateProjects: (state, action) => {
            state.projects = action.payload;
        },
        updateSelectedProjectId: (state, action) => {
            state.selectedProjectId = action.payload;
        },
        updateExperiment: (state, action) => {
            state.experiment = action.payload;
        },
        updateLoadingProjects: (state, action) => {
            state.loadingProjects = action.payload;
        },
        updateShowingFinishModal: (state, action) => {
            state.showingFinishModal = action.payload;
        },
        updateFeedback: (state, action) => {
            state.feedback = action.payload;
        },
    },
});
// Export actions
export const { updateProjects, updateSelectedProjectId, updateExperiment, updateLoadingProjects, updateShowingFinishModal, updateFeedback, } = experimentSlice.actions;
// Thunk Actions (kept as regular thunks due to cross-module dispatches)
export const finishExperiment = () => (dispatch, getState) => {
    const { experiment: { feedback }, organizations: { currentOrganization }, } = getState();
    socketClient.sendMessage({
        type: TYPE_EXPERIMENT,
        status: EXPERIMENT_STATUS_FINISH,
        feedback,
    });
    socketClient.sendMessage({
        type: TYPE_DEVICE,
        status: DEVICE_STATUS_AVAILABLE,
    });
    dispatch(updateScript(''));
    dispatch(onScriptEnds(Date.now()));
    dispatch(updateShowingFinishModal(false));
    dispatch(updateFeedback(''));
    dispatch(updateMoveBackbone([]));
    navigationService.push(instrumentsUrl(currentOrganization.slug || ''));
};
export const selectProject = (projectId) => (dispatch) => {
    dispatch(updateSelectedProjectId(projectId));
    dispatch(startExperiment());
    navigationService.push(ANACONDA_URL);
};
export const loadProjects = () => async (dispatch, getState) => {
    const state = getState();
    const { currentOrganization } = state.organizations;
    const { devices, selectedDeviceId } = state.devices;
    // Get organization slug from currentOrganization, or fallback to the selected device's workspace
    const selectedDevice = devices.find((d) => d.id === selectedDeviceId);
    const organizationSlug = currentOrganization?.slug || selectedDevice?.workspace;
    if (!organizationSlug) {
        // No organization available yet, set empty projects
        dispatch(updateProjects([]));
        return;
    }
    dispatch(updateLoadingProjects(true));
    const { body } = await apiClient.get('/projects', {
        organization: organizationSlug,
    });
    const projects = body.map((project) => ({
        name: project.title,
        id: project.id,
    }));
    dispatch(updateProjects(projects));
    dispatch(updateLoadingProjects(false));
};
// Export reducer as default
export default experimentSlice.reducer;
